import { withPrefix } from 'gatsby'

export default [
  { src: withPrefix('slider/construction--tower-from-park.jpg'), isCGI: true, hasDarkCGILabel: true },
  { src: withPrefix('slider/construction--room-through-window.jpg'), isCGI: true, hasDarkCGILabel: false },
  { src: withPrefix('slider/construction--tower-with-cityscape-day.jpg'), isCGI: true, hasDarkCGILabel: false },
  { src: withPrefix('slider/construction--tower-from-street.jpg'), isCGI: true, hasDarkCGILabel: true },
  { src: withPrefix('slider/construction--tower-with-cityscape-night.jpg'), isCGI: true, hasDarkCGILabel: false },
]
